export default __webpack_public_path__ + "static/media/neon_boom_box.70038852.svg";